export default [
  {
    description:
      'Pandemi COVID-19 memiliki berbagai dampak terhadap dunia usaha, sejumlah sektor usaha mengalami pertumbuhan positif, namun sebaliknya tidak sedikit pula sektor usaha yang mengalami pertumbuhan yang negatif.',
    title: 'Sekilas Mengenai UMP 21',
    media: ['https://i.imgur.com/3hObKOR.mp4']
  }
]
